module.exports = __webpack_public_path__ + "static/media/laptop-code.87c7fcd9.svg";